/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { InactiveCleanupCandidatesRequestDTOToJSON, InactiveCleanupCriteriaDTOToJSON, InactiveCleanupExportDTOFromJSON, InactiveCleanupPreviewDTOFromJSON, InactiveCleanupRunDTOFromJSON, InactiveCleanupStartRequestDTOToJSON, InactiveCleanupSummaryDTOFromJSON, PaginatedResponseInactiveCleanupCandidateDTOFromJSON, } from '../models/index';
/**
 *
 */
export class InactiveCleanupControllerApi extends runtime.BaseAPI {
    /**
     */
    async cancelInactiveCleanupRunRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling cancelInactiveCleanupRun().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/runs/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InactiveCleanupRunDTOFromJSON(jsonValue));
    }
    /**
     */
    async cancelInactiveCleanupRun(requestParameters, initOverrides) {
        const response = await this.cancelInactiveCleanupRunRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async exportInactiveCleanupCandidatesRaw(requestParameters, initOverrides) {
        if (requestParameters['inactiveCleanupCriteriaDTO'] == null) {
            throw new runtime.RequiredError('inactiveCleanupCriteriaDTO', 'Required parameter "inactiveCleanupCriteriaDTO" was null or undefined when calling exportInactiveCleanupCandidates().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/export`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InactiveCleanupCriteriaDTOToJSON(requestParameters['inactiveCleanupCriteriaDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InactiveCleanupExportDTOFromJSON(jsonValue));
    }
    /**
     */
    async exportInactiveCleanupCandidates(requestParameters, initOverrides) {
        const response = await this.exportInactiveCleanupCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getInactiveCleanupRunRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getInactiveCleanupRun().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/runs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InactiveCleanupRunDTOFromJSON(jsonValue));
    }
    /**
     */
    async getInactiveCleanupRun(requestParameters, initOverrides) {
        const response = await this.getInactiveCleanupRunRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listInactiveCleanupCandidatesRaw(requestParameters, initOverrides) {
        if (requestParameters['inactiveCleanupCandidatesRequestDTO'] == null) {
            throw new runtime.RequiredError('inactiveCleanupCandidatesRequestDTO', 'Required parameter "inactiveCleanupCandidatesRequestDTO" was null or undefined when calling listInactiveCleanupCandidates().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/candidates`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InactiveCleanupCandidatesRequestDTOToJSON(requestParameters['inactiveCleanupCandidatesRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseInactiveCleanupCandidateDTOFromJSON(jsonValue));
    }
    /**
     */
    async listInactiveCleanupCandidates(requestParameters, initOverrides) {
        const response = await this.listInactiveCleanupCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listInactiveCleanupRunsRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling listInactiveCleanupRuns().');
        }
        const queryParameters = {};
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/runs`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InactiveCleanupRunDTOFromJSON));
    }
    /**
     */
    async listInactiveCleanupRuns(requestParameters, initOverrides) {
        const response = await this.listInactiveCleanupRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async previewInactiveCleanupRaw(requestParameters, initOverrides) {
        if (requestParameters['inactiveCleanupCriteriaDTO'] == null) {
            throw new runtime.RequiredError('inactiveCleanupCriteriaDTO', 'Required parameter "inactiveCleanupCriteriaDTO" was null or undefined when calling previewInactiveCleanup().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/preview`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InactiveCleanupCriteriaDTOToJSON(requestParameters['inactiveCleanupCriteriaDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InactiveCleanupPreviewDTOFromJSON(jsonValue));
    }
    /**
     */
    async previewInactiveCleanup(requestParameters, initOverrides) {
        const response = await this.previewInactiveCleanupRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async startInactiveCleanupRunRaw(requestParameters, initOverrides) {
        if (requestParameters['inactiveCleanupStartRequestDTO'] == null) {
            throw new runtime.RequiredError('inactiveCleanupStartRequestDTO', 'Required parameter "inactiveCleanupStartRequestDTO" was null or undefined when calling startInactiveCleanupRun().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/runs`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InactiveCleanupStartRequestDTOToJSON(requestParameters['inactiveCleanupStartRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InactiveCleanupRunDTOFromJSON(jsonValue));
    }
    /**
     */
    async startInactiveCleanupRun(requestParameters, initOverrides) {
        const response = await this.startInactiveCleanupRunRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async summarizeInactiveCleanupRaw(requestParameters, initOverrides) {
        if (requestParameters['inactiveCleanupCriteriaDTO'] == null) {
            throw new runtime.RequiredError('inactiveCleanupCriteriaDTO', 'Required parameter "inactiveCleanupCriteriaDTO" was null or undefined when calling summarizeInactiveCleanup().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/inactive-cleanup/summary`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InactiveCleanupCriteriaDTOToJSON(requestParameters['inactiveCleanupCriteriaDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InactiveCleanupSummaryDTOFromJSON(jsonValue));
    }
    /**
     */
    async summarizeInactiveCleanup(requestParameters, initOverrides) {
        const response = await this.summarizeInactiveCleanupRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ListInactiveCleanupRunsMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
